export enum PackageState {
    Completed = 'Completed',
    NotUploaded = 'NotUploaded',
    Uploading = 'Uploading',
    Importing = 'Importing',
    Processing = 'Processing',
    Broken = 'Broken',
    UploadedWithoutAnalysis = 'UploadedWithoutAnalysis',
}